import { render, staticRenderFns } from "./Reload.vue?vue&type=template&id=6bd54bfb"
import script from "./Reload.vue?vue&type=script&lang=js"
export * from "./Reload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports